module.exports = __webpack_public_path__ + "static/media/arrow-up-white.badb68b1.svg";